import { z } from "zod";

const PAGE_SIZE = 10;
export const templateStatusSchema = z.enum(["active", "inactive"]);
export const roleSortBySchema = z.enum([
  "nameEn",
  "nameAr",
  "permissionsCount",
  "status",
  "createdAt",
]);
export const rolesSearchSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(PAGE_SIZE),
  sort: z.enum(["asc", "desc"]).optional(),
  sortBy: roleSortBySchema.optional(),
  search: z.string().trim().min(1).optional(),
  status: templateStatusSchema.optional(),
});
export type RolesSearch = z.infer<typeof rolesSearchSchema>;
export type TemplateStatus = z.infer<typeof templateStatusSchema>;
